import { createClient } from '@supabase/supabase-js';

// Chegada pelo link de redefinição de senha (ou de boas-vindas, que é o mesmo
// link de recovery). Marca ANTES do createClient: o cliente lê e apaga o hash
// da URL ao iniciar, e o evento PASSWORD_RECOVERY pode disparar antes de o App
// assinar o onAuthStateChange — aí a pessoa entrava direto, sem trocar a senha.
// A marca fica na sessionStorage para sobreviver a um F5 até a senha ser trocada.
export const CHAVE_RECOVERY = 'kz-recovery-pendente';
try {
  if (/(^|[#&?])type=recovery(&|$)/.test(window.location.hash + window.location.search)) {
    sessionStorage.setItem(CHAVE_RECOVERY, '1');
  }
} catch { /* sessionStorage indisponível: segue só pelo evento */ }

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
